const aiChannels = [
  { label: 'WhatsApp', value: 'whatsapp' },
  { label: 'Phone call', value: 'call' },
];

const aiOutcomes = [
  { label: 'Positive Closure', value: 'positive' },
  { label: 'Negative Closure', value: 'negative' },
  { label: 'Schedule appointment', value: 'appointment' },
];

const aiRoutingModes = [
  { label: 'Autonomous', value: 'autonomous' },
  { label: 'Pre-qualify', value: 'prequalify' },
];

// The models allowed for the conversation engine, the same list as Chiedimi.
// The list is deliberately closed: a hand-typed model OpenRouter does not know
// would fail every conversation, and the failure would show only at runtime.
//
// Cheaper models were tried on Chiedimi and dropped: they are not enough where
// the ORDER of what is said is the requirement — naming a product before the
// lead has been qualified for it, or promising a call back nobody would make.
//
// Because the list is closed, a stored agent left on a value no longer listed
// fails this file's validation the next time somebody opens the form:
// migrating the `aiAgents` documents belongs with any change to it.
//
// The list is closed and single on purpose. If the model is ever unavailable
// there is no configured spare, which is one line to add and worth knowing
// before it happens rather than during.
const aiModels = [
  { label: 'Claude Sonnet 5.5', value: 'anthropic/claude-sonnet-5.5' },
];

export { aiChannels, aiOutcomes, aiRoutingModes, aiModels };
